// frontend/src/components/session/SessionWarningDialog.jsx
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { ICON, Clock } from '../../icons';
import { formatTime } from '../../hooks/useSessionTimeout';
import './SessionWarningDialog.css';
import { useTranslation } from 'react-i18next';

const SessionWarningDialog = ({ open, timeLeft, onStayLoggedIn }) => {
  const { t } = useTranslation();
  const isCritical = timeLeft < 30000;

  return (
    <Dialog
      open={open}
      className="dialog-form dialog-form--confirm session-warning-dialog"
      onClose={(event, reason) => {
        if (reason === 'backdropClick' || reason === 'escapeKeyDown') return;
      }}
    >
      <DialogTitle>{t('session.expiring')}</DialogTitle>
      <DialogContent className="session-warning-body">
        <div className={`session-warning-icon-wrapper ${isCritical ? 'critical' : ''}`}>
          <Clock className="session-warning-icon" size={ICON.display} />
        </div>

        <p className="session-warning-message">{t('session.expiringMessage')}</p>

        <div className="session-warning-countdown">
          <span className="session-warning-label">{t('session.timeRemaining')}</span>
          <span className={`session-warning-time ${isCritical ? 'critical' : ''}`}>
            {formatTime(timeLeft)}
          </span>
        </div>
      </DialogContent>
      <DialogActions>
        <Button variant="contained" onClick={onStayLoggedIn}>
          {t('session.stayLoggedIn')}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SessionWarningDialog;
